import { Button, Typography } from "@hellocarbo/lasagne";

import logo from "@/assets/logo.svg";

type SignUpFormStepProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  buttonText: string;
  onClick: () => void;
  secondaryAction?: React.ReactNode;
};

const SignUpFormStep = ({
  title,
  subtitle,
  children,
  buttonText,
  onClick,
  secondaryAction,
}: SignUpFormStepProps) => {
  return (
    <div className="gap-lg flex flex-col">
      <img src={logo} className="size-2xl mx-auto" />
      <div>
        <Typography step="3" as="h1" autoSpacing>
          {title}
        </Typography>
        {subtitle && (
          <Typography step="0" as="p" className="text-grayscale">
            {subtitle}
          </Typography>
        )}
      </div>
      <div>{children}</div>
      <div className="space-y-xs">
        <Button fullWidth onClick={onClick}>
          {buttonText}
        </Button>
        {secondaryAction}
      </div>
    </div>
  );
};

export default SignUpFormStep;
